export default __webpack_public_path__ + "static/media/mo.ba54ad4b.svg";